import React, { useState, useEffect } from 'react';
import { settingService } from '../../../services';
import { useModalDialog, useQueryParams, useMessage } from '../../../hooks';
import { Tabs, Input, SelectButtons, formatSelectOptions, Checkbox } from '../../../components'
import { useSettingDialog } from '../hooks';


export const Settings = ({setModalDialog, cancelModalDialog }) => {
  
  const { queryParams, setHistory } = useQueryParams()

  const [settings, setSettings] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [defaultSelectedTab, setDefaultSelectedTab] = useState({tab: queryParams.tab})

  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showEditSettingDialog } = useSettingDialog()

  useEffect(() => {

    fetchItems()
    
  }, []);

  const fetchItems = async () => {
    await settingService.getAll()
      .then(res => {

        let result = {}
        res.settings.forEach(setting => {
          result[setting.setting_code] = {...setting}
        })
        setSettings(result)
        setFormData(result)
      })
      .catch(err => {
        showMessage(JSON.stringify(err), 'error')
      })
      .finally(res => setLoading(false)) 
  }

  const editSettings = async data => {
    await settingService.update(data)
      .then(async res => {
        fetchItems()
        showMessage(res)
        hideModalDialog()
      })
      .catch(err => {
        showMessage(JSON.stringify(err), 'error')
      });
  }

  // Closing happens in editSettings' success branch, not here — hiding before the submit
  // meant a failed save closed the dialog and left only an error toast.
  const saveSettings = (event) => {
    onSubmit(event)
  }

  const handleInputChange = (event) => {

    let { name, value } = ""

    // Handle standard form inputs
    if (event.target !== undefined) {
      name = event.target.name
      value = event.target.value

      // If input element is a checkbox, we cannot use "value"
      if (event.target.type === "checkbox") { value = event.target.checked }

    // Handle custom form inputs
    } else {
      name = event.name
      value = event.value
    }

    setFormData({ ...formData, [name]: {...formData[name], setting_value: value} })

  }

  const onSubmit = event => {
    event.preventDefault()
    
    // Form validation
    //if (!formData.user_fullname || !formData.user_username) return

    setLoading(true)

    const data = Object.entries(formData).map( ([key, value]) => {
      return { setting_id: value.setting_id, setting_value: value.setting_value }
    })

    // submit form
    editSettings({settings: data})
    .catch(err => {})   
    .finally(res => setLoading(false))    
        
  }

  const cancel = () => {
    setFormData(settings)
  }

  const onTabChange = (tab) => {
    setHistory({'tab': tab})
  }

  return (
    <div className="wide-margin">
      <div className="form">
        <form>
          
          <Tabs className="slim left"
            onTabChange={ onTabChange } 
            defaultSelectedTab={ defaultSelectedTab }
            disableTabsWithoutResults={ true }
          >
         
            <div label="Authenticaton" tabid="authentication">
            
              <div className="form-content">

                <div className="form-block vertical">
                  <Checkbox 
                    checked={formData?.LOCAL_IS_ENABLED?.setting_value  || false}
                    name={formData?.LOCAL_IS_ENABLED?.setting_code}
                    label={formData?.LOCAL_IS_ENABLED?.setting_name}
                    onChange={ handleInputChange}
                    disabled={loading}
                    title={formData?.LOCAL_IS_ENABLED?.setting_description}
                  />
                </div>

                <div className="form-block vertical">
                  <Checkbox 
                    checked={formData?.OIDC_IS_ENABLED?.setting_value || false}
                    name={formData?.OIDC_IS_ENABLED?.setting_code}
                    label={formData?.OIDC_IS_ENABLED?.setting_name}
                    onChange={ handleInputChange}
                    disabled={loading}
                    title={formData?.OIDC_IS_ENABLED?.setting_description}
                  />
                </div>
                
                {formData?.OIDC_IS_ENABLED?.setting_value && 
                <div>
                
                  <div className="form-block vertical">
                  <h4>Azure OpenID Connect Parameters</h4>
                    <Input type="text" 
                      name={formData?.OIDC_DIRECTORY_ID?.setting_code}
                      label={formData?.OIDC_DIRECTORY_ID?.setting_name}
                      value={formData?.OIDC_DIRECTORY_ID?.setting_value || ''} 
                      onChange={handleInputChange}
                      disabled={loading}
                      title={formData?.OIDC_DIRECTORY_ID?.setting_description}
                    />
                  </div>

                  <div className="form-block vertical">
                    <Input type="text" 
                      name={formData?.OIDC_APPLICATION_ID?.setting_code}
                      label={formData?.OIDC_APPLICATION_ID?.setting_name}
                      value={formData?.OIDC_APPLICATION_ID?.setting_value || ''} 
                      onChange={handleInputChange}
                      disabled={loading}
                      title={formData?.OIDC_APPLICATION_ID?.setting_description}
                    />
                  </div>

                  <div className="form-block vertical">
                    <Input type="password" 
                      name={formData?.OIDC_CLIENT_SECRET?.setting_code}
                      label={formData?.OIDC_CLIENT_SECRET?.setting_name}
                      value={formData?.OIDC_CLIENT_SECRET?.setting_value || ''} 
                      onChange={handleInputChange}
                      disabled={loading}
                      placeholder="< hidden >"
                      title={formData?.OIDC_CLIENT_SECRET?.setting_description}
                    />
                  </div>

                  <div className="form-block vertical">
                    <Input type="text" 
                      name={formData?.OIDC_REDIRECT_URI?.setting_code}
                      label={formData?.OIDC_REDIRECT_URI?.setting_name}
                      value={formData?.OIDC_REDIRECT_URI?.setting_value || ''} 
                      onChange={handleInputChange}
                      disabled={loading}
                      title={formData?.OIDC_REDIRECT_URI?.setting_description}
                    />
                  </div>
                </div>
                }
              </div>
            </div>

            <div label="User Provisioning" tabid="userProvisioning">
              <div className="form-content">

                  <h4>Azure AD (through Microsoft Graph API)</h4>

                { formData?.OIDC_IS_ENABLED?.setting_value ? 
                  <React.Fragment>
                    <div className="form-block vertical">
                      <Input type="text" 
                        name={formData?.MSGRAPH_USER_BASE_FILTER?.setting_code}
                        label={formData?.MSGRAPH_USER_BASE_FILTER?.setting_name}
                        value={formData?.MSGRAPH_USER_BASE_FILTER?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        title={formData?.MSGRAPH_USER_BASE_FILTER?.setting_description}
                      />
                    </div>

                    <div className="form-block vertical">
                      <Input type="text" 
                        name={formData?.MSGRAPH_GROUP_BASE_FILTER?.setting_code}
                        label={formData?.MSGRAPH_GROUP_BASE_FILTER?.setting_name}
                        value={formData?.MSGRAPH_GROUP_BASE_FILTER?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        title={formData?.MSGRAPH_GROUP_BASE_FILTER?.setting_description}
                      />
                    </div>

                    <div className="form-block vertical">
                      <Checkbox 
                        checked={formData?.SYNC_NESTED_USER_GROUPS?.setting_value || false}
                        name={formData?.SYNC_NESTED_USER_GROUPS?.setting_code}
                        label={formData?.SYNC_NESTED_USER_GROUPS?.setting_name}
                        onChange={ handleInputChange}
                        disabled={loading}
                        title={formData?.SYNC_NESTED_USER_GROUPS?.setting_description}
                      />
                    </div>

                    

                    <div className="form-block vertical">
                      <h4>User Attribute Mapping</h4>
                      <Input type="text" 
                        name={formData?.USER_SOURCE_ID?.setting_code}
                        label={formData?.USER_SOURCE_ID?.setting_name}
                        value={formData?.USER_SOURCE_ID?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_SOURCE_ID?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_USERNAME?.setting_code}
                        label={formData?.USER_USERNAME?.setting_name}
                        value={formData?.USER_USERNAME?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_USERNAME?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_FULLNAME?.setting_code}
                        label={formData?.USER_FULLNAME?.setting_name}
                        value={formData?.USER_FULLNAME?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_FULLNAME?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_EMAIL?.setting_code}
                        label={formData?.USER_EMAIL?.setting_name}
                        value={formData?.USER_EMAIL?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_EMAIL?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_PHONE?.setting_code}
                        label={formData?.USER_PHONE?.setting_name}
                        value={formData?.USER_PHONE?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_PHONE?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_LINKEDIN_VANITY_NAME?.setting_code}
                        label={formData?.USER_LINKEDIN_VANITY_NAME?.setting_name}
                        value={formData?.USER_LINKEDIN_VANITY_NAME?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_LINKEDIN_VANITY_NAME?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.USER_TITLE?.setting_code}
                        label={formData?.USER_TITLE?.setting_name}
                        value={formData?.USER_TITLE?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_TITLE?.setting_description}
                      />
                    
                      <Input type="text" 
                        name={formData?.USER_DEPARTMENT?.setting_code}
                        label={formData?.USER_DEPARTMENT?.setting_name}
                        value={formData?.USER_DEPARTMENT?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.USER_DEPARTMENT?.setting_description}
                      />
                    </div>

                    <div className="form-block vertical">
                      <h4>User Group Attribute Mapping</h4>
                      <Input type="text" 
                        name={formData?.GROUP_SOURCE_ID?.setting_code}
                        label={formData?.GROUP_SOURCE_ID?.setting_name}
                        value={formData?.GROUP_SOURCE_ID?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.GROUP_SOURCE_ID?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.GROUP_NAME?.setting_code}
                        label={formData?.GROUP_NAME?.setting_name}
                        value={formData?.GROUP_NAME?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.GROUP_NAME?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.GROUP_EMAIL?.setting_code}
                        label={formData?.GROUP_EMAIL?.setting_name}
                        value={formData?.GROUP_EMAIL?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.GROUP_EMAIL?.setting_description}
                      />

                      <Input type="text" 
                        name={formData?.GROUP_DESCRIPTION?.setting_code}
                        label={formData?.GROUP_DESCRIPTION?.setting_name || ''}
                        value={formData?.GROUP_DESCRIPTION?.setting_value} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.GROUP_DESCRIPTION?.setting_description}
                      />
                    </div>
                  </React.Fragment>

                  : <div className="form-block vertical">
                      To use this feature, authentication through Azure OpenID Connect must be enabled and correctly configured.
                    </div>
              }
              </div>
            
            </div>

            <div label="Mailing" tabid="mailing">
              <div className="form-content">

                <div className="form-block vertical">
                  <Checkbox 
                      checked={formData?.MAIL_IS_ENABLED?.setting_value  || false}
                      name={formData?.MAIL_IS_ENABLED?.setting_code}
                      label={formData?.MAIL_IS_ENABLED?.setting_name}
                      onChange={ handleInputChange}
                      disabled={loading}
                      title={formData?.MAIL_IS_ENABLED?.setting_description}
                    />
                </div>

              { formData?.MAIL_IS_ENABLED?.setting_value &&

                <React.Fragment>
                <div className="form-block vertical">
                <div className="form-block vertical">
                  <SelectButtons 
                    name={formData?.MAIL_TRANSPORTER?.setting_code}
                    label={formData?.MAIL_TRANSPORTER?.setting_name}
                    value={formData?.MAIL_TRANSPORTER?.setting_value || 0}
                    options={ formatSelectOptions({options: [{label: 'Azure', value:'msgraph'}, {label: 'SMTP', value:'smtp'}], optionValue: "value", optionLabel: "label"}) }
                    onChange={handleInputChange} 
                    disabled={loading}
                    title={formData?.MAIL_TRANSPORTER?.setting_description}
                  />
                </div>
                </div>

                { formData?.MAIL_TRANSPORTER?.setting_value === "smtp" &&
                  <React.Fragment>
                    <div className="form-block vertical">
                      <h4>SMTP Configuration</h4>
                      <Input type="text" 
                        name={formData?.MAIL_HOST?.setting_code}
                        label={formData?.MAIL_HOST?.setting_name}
                        value={formData?.MAIL_HOST?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.MAIL_HOST?.setting_description}
                      />
                      <Input type="text" 
                        name={formData?.MAIL_PORT?.setting_code}
                        label={formData?.MAIL_PORT?.setting_name}
                        value={formData?.MAIL_PORT?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        placeholder={formData?.MAIL_IS_SECURE?.setting_value ? 465 : 587}
                        title={formData?.MAIL_PORT?.setting_description}
                      />
                    </div>
                    <div className="form-block vertical">
                      <Checkbox 
                        checked={formData?.MAIL_IS_SECURE?.setting_value  || false}
                        name={formData?.MAIL_IS_SECURE?.setting_code}
                        label={formData?.MAIL_IS_SECURE?.setting_name}
                        onChange={ handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.MAIL_IS_SECURE?.setting_description}
                      />
                    </div>
                    <div className="form-block vertical">
                      <Input type="text" 
                        name={formData?.MAIL_USERNAME?.setting_code}
                        label={formData?.MAIL_USERNAME?.setting_name}
                        value={formData?.MAIL_USERNAME?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.MAIL_USERNAME?.setting_description}
                      />
                      <Input type="password" 
                        name={formData?.MAIL_PASSWORD?.setting_code}
                        label={formData?.MAIL_PASSWORD?.setting_name}
                        value={formData?.MAIL_PASSWORD?.setting_value || ''} 
                        onChange={handleInputChange}
                        disabled={loading}
                        placeholder="< hidden >"
                        labelPosition="left"
                        title={formData?.MAIL_PASSWORD?.setting_description}
                      />
                      <Input type="text" 
                        name={formData?.MAIL_FROM?.setting_code}
                        label={formData?.MAIL_FROM?.setting_name || ''}
                        value={formData?.MAIL_FROM?.setting_value} 
                        onChange={handleInputChange}
                        disabled={loading}
                        labelPosition="left"
                        title={formData?.MAIL_FROM?.setting_description}
                      />
                    </div>
                  </React.Fragment>

                }

                { formData?.OIDC_IS_ENABLED?.setting_value && formData?.MAIL_TRANSPORTER?.setting_value === "msgraph" && 
                  <div className="form-block vertical">
                    <h4>Microsoft Graph Configuration</h4>
                    <Input type="text" 
                      name={formData?.MAIL_FROM?.setting_code}
                      label={formData?.MAIL_FROM?.setting_name || ''}
                      value={formData?.MAIL_FROM?.setting_value} 
                      onChange={handleInputChange}
                      disabled={loading}
                      labelPosition={formData?.MAIL_TRANSPORTER?.setting_value === 'smtp' ? "left" : undefined}
                      title={formData?.MAIL_FROM?.setting_description}
                    />
                  </div>
                }
                { !formData?.OIDC_IS_ENABLED?.setting_value && formData?.MAIL_TRANSPORTER?.setting_value === "msgraph" &&
                  <div className="form-block vertical">
                    To send emails through Azure (Microsoft Graph API), authentication through Azure OpenID Connect must be enabled and correctly configured.
                  </div>
                }
                </React.Fragment>
              }
              </div>
            </div>

            <div label="Logging" tabid="logging">
              <div className="form-content">

                <div className="form-block vertical">
                  <SelectButtons 
                    name={formData?.LOG_LEVEL?.setting_code}
                    label={formData?.LOG_LEVEL?.setting_name}
                    value={formData?.LOG_LEVEL?.setting_value || 0}
                    options={ formatSelectOptions({options: [{label: 'Info', value:'info'}, {label: 'Debug', value:'debug'}], optionValue: "value", optionLabel: "label"}) }
                    onChange={handleInputChange} 
                    disabled={loading}
                    title={formData?.LOG_LEVEL?.setting_description}
                  />
                </div>

              </div>
            </div>

          </Tabs>
          
          { formData && 
            <div className="form-block horizontal">
              <button 
                type="button" 
                className={"button main-button" + (loading ? ' loading' : '')} 
                disabled={loading}
                onClick={(event) => {event.preventDefault(); showEditSettingDialog(() => saveSettings(event));}}
                >
                <span>{loading ? 'SAVING...' : 'SAVE' }</span>
              </button>
              <button 
                type="button" 
                className="button" 
                onClick={cancel}
                disabled={loading}>
                <span>CANCEL</span>
              </button>
            </div>
          }

        </form>
        </div>

      </div>
  );
}